import { FormField } from "@maysoft/common-component-react"
import { Paper } from "@mui/material"

type Props = {
    value: string
    onChange: (val: string) => void
    label?: string
}

const SimpleSettingForm = ({
    value,
    onChange,
    label = "Value"
}: Props) => {
    return (
        <Paper
            sx={{
                p: 2,
                borderRadius: 2
            }}
        >
            <FormField
                fullWidth
                label={label}
                value={value}
                onChangeValue={onChange}
            />
        </Paper>
    )
}

export default SimpleSettingForm